import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import photo from "../../Assets/profile-photo2.jpg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn, FaFacebookF, FaTwitter } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I’m <b className="purple">Muhammad Faseeh Hassan</b>, a passionate
              full-stack developer with a strong interest in{" "}
              <b className="purple">AI, AR, and web/mobile app development</b>.
              <br />
              <br />
              I’m fluent in programming languages like
              <i>
                <b className="purple"> C++, JavaScript, Python, and PHP</b>
              </i>
              , and I specialize in building modern web apps using
              <i>
                <b className="purple"> React.js, Node.js, and Flutter</b>.
              </i>
              <br />
              <br />
              My notable projects include:
              <ul>
                <li>
                  <b className="purple">Xpert-Aid</b> – an AI-based medical
                  diagnostic system using MERN, CNN, and Random Forest.
                </li>
                <li>
                  <b className="purple">ArtSpark</b> – a Flutter-based AR art
                  marketplace using Firebase and Google ARCore.
                </li>
                <li>
                  Real-time <b className="purple">fire detection</b> with YOLOv8
                  and emotion recognition with CNN.
                </li>
              </ul>
              <br />
              I’m always eager to explore new technologies and build impactful
              solutions. Whether it’s deploying full-stack apps, integrating
              machine learning, or crafting immersive mobile experiences — I’m
              all in!
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img
                src={photo}
                className="img-fluid"
                style={{ borderRadius: "50%", height: 250, width: 250 }}
                alt="avatar"
              />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect</span> with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://www.facebook.com/share/zF8EntmwWwzYwWBh/?mibextid=qi2Omg"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaFacebookF />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/rajafaseeh41"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://github.com/faseeh41"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/muhammad-faseeh-hassan/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/faseeh_403/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
